import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@/store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppState: TypedUseSelectorHook<RootState> = useSelector;

export { default as useBoolean } from './useBoolean';
export { default as useHover } from './useHover';
export { default as useLocale } from './useLocale';
export { default as useInfiniteScroll } from './useInfiniteScroll';
export { default as useThemeToken } from './useThemeToken';
export { default as usePagination } from './usePagination';
export { default as useModal } from './useModal';
export { default as useCopyToClipboard } from './useCopyToClipboard';
export * from './formValidations';
